import { createSlice } from "@reduxjs/toolkit";
import {
  GetAllChatDetails,
  GetAllChatList,
  GetAllChatReports,
  GetAllRequests,
  GetAllStories,
} from "store/middlewares/chatReport";

export const chatReportSlice = createSlice({
  name: "chatReport",
  initialState: {
    chatListLoading: true,
    chatList: null,
    chatDetailsLoading: true,
    chatDetails: null,
    chatReportsLoading: false,
    chatReports: null,
    requestsLoading: true,
    requests: null,
    storiesLoading: true,
    stories: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      // Get dashboard
      .addCase(GetAllChatList.pending, (state) => {
        // state.chatListLoading =
        //   state.chatList?.inbox?.length > 0 ? false : true;
        state.chatList =
          state.chatList?.inbox?.length > 0 ? state.chatList : null;
      })
      .addCase(GetAllChatList.fulfilled, (state, action) => {
        state.chatListLoading = false;
        state.chatList = action.payload.response;
      })
      .addCase(GetAllChatList.rejected, (state) => {
        state.chatListLoading = false;
        state.chatList = null;
      })

      .addCase(GetAllChatDetails.pending, (state) => {
        state.chatDetailsLoading = state.chatDetails?.length > 0 ? false : true;
        state.chatDetails =
          state.chatDetails?.length > 0 ? state.chatDetails : null;
      })
      .addCase(GetAllChatDetails.fulfilled, (state, action) => {
        state.chatDetailsLoading = false;
        state.chatDetails = action.payload.response;
      })
      .addCase(GetAllChatDetails.rejected, (state) => {
        state.chatDetailsLoading = false;
        state.chatDetails = null;
      })

      .addCase(GetAllChatReports.pending, (state) => {
        state.chatReportsLoading =
          state.chatReports?.result?.length > 0 ? false : true;
        state.chatReports =
          state.chatReports?.result?.length > 0 ? state.chatReports : null;
      })
      .addCase(GetAllChatReports.fulfilled, (state, action) => {
        state.chatReportsLoading = false;
        state.chatReports = action.payload.response;
      })
      .addCase(GetAllChatReports.rejected, (state) => {
        state.chatReportsLoading = false;
        state.chatReports = null;
      })

      .addCase(GetAllRequests.pending, (state) => {
        // state.requestsLoading = state.requests?.data?.length > 0 ? false : true;
        state.requests =
          state.requests?.data?.length > 0 ? state.requests : null;
      })
      .addCase(GetAllRequests.fulfilled, (state, action) => {
        state.requestsLoading = false;
        state.requests = action.payload.response;
      })
      .addCase(GetAllRequests.rejected, (state) => {
        state.requestsLoading = false;
        state.requests = null;
      })

      .addCase(GetAllStories.pending, (state) => {
        // state.storiesLoading = state.stories?.result?.length > 0 ? false : true;
        state.stories =
          state.stories?.result?.length > 0 ? state.stories : null;
      })
      .addCase(GetAllStories.fulfilled, (state, action) => {
        state.storiesLoading = false;
        state.stories = action.payload.response;
      })
      .addCase(GetAllStories.rejected, (state) => {
        state.storiesLoading = false;
        state.stories = null;
      });
  },
});

export default chatReportSlice.reducer;
